import { NgModule } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { BlockUIModule } from 'primeng/blockui';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DockModule } from 'primeng/dock';
import { SelectModule } from 'primeng/select';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { MenubarModule } from 'primeng/menubar';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DrawerModule } from 'primeng/drawer';
import { SliderModule } from 'primeng/slider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { TreeModule } from 'primeng/tree';

import { PopoverModule } from 'primeng/popover';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DividerModule } from 'primeng/divider';
import { PasswordModule } from 'primeng/password';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { CarouselModule } from 'primeng/carousel';
import { InplaceModule } from 'primeng/inplace';
import { InputMaskModule } from 'primeng/inputmask';
import { SplitterModule } from 'primeng/splitter';
import { ListboxModule } from 'primeng/listbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { TreeTableModule } from 'primeng/treetable';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { DataViewModule } from 'primeng/dataview';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { Textarea } from 'primeng/textarea';
import { TabsModule } from 'primeng/tabs';
import { TreeSelectModule } from 'primeng/treeselect';

const modules = [
    AccordionModule,
    AutoCompleteModule,
    AvatarModule,
    AvatarGroupModule,
    BadgeModule,
    BlockUIModule,
    BreadcrumbModule,
    ButtonModule,
    SelectModule,
    CardModule,
    CarouselModule,
    CheckboxModule,
    ChipModule,
    ConfirmPopupModule,
    ColorPickerModule,
    DialogModule,
    DockModule,
    DividerModule,
    DynamicDialogModule,
    IconFieldModule,
    InputIconModule,
    InputMaskModule,
    InplaceModule,
    InputTextModule,
    MenubarModule,
    PopoverModule,
    PanelModule,
    PanelMenuModule,
    PasswordModule,
    ListboxModule,
    ProgressBarModule,
    RadioButtonModule,
    RippleModule,
    SelectButtonModule,
    DrawerModule,
    StepsModule,
    SliderModule,
    SplitButtonModule,
    TableModule,
    TabsModule,
    ToastModule,
    TieredMenuModule,
    ToolbarModule,
    ToggleButtonModule,
    TreeModule,
    TagModule,
    SplitterModule,
    InputNumberModule,
    TreeTableModule,
    Textarea,
    ScrollPanelModule,
    DataViewModule,
    TreeSelectModule
];

@NgModule({
    imports: modules,
    exports: modules
})
export class primeNgModule { }
